module.exports = __webpack_public_path__ + "static/img/2_car.ff1e5d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/2_car.png
// module id = fpMi
// module chunks = 0